import { render, staticRenderFns } from "./AccountProjects.vue?vue&type=template&id=1b47f0a0&"
import script from "./AccountProjects.vue?vue&type=script&lang=js&"
export * from "./AccountProjects.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports